"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Loader, Cpu, Wrench, Mail, Phone, MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
function InquiryForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-primary/10 border border-primary/20 rounded-md flex flex-col items-center justify-center text-center h-full min-h-[400px]">
                <div className="size-12 rounded-md bg-primary/20 flex items-center justify-center mb-4">
                    <Cpu className="size-6 text-primary" />
                </div>
                <h3 className="font-default text-xl font-semibold text-foreground mb-2">Inquiry Received</h3>
                <p className="text-muted-foreground mb-6 max-w-md">{successMessage}</p>
                <Button onClick={resetForm} variant="outline" className="rounded-md border-primary/50 hover:bg-primary/10">
                    Submit Another Inquiry
                </Button>
            </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormField control={control} name="name" rules={{
        required: "Name is required",
        minLength: {
          value: 2,
          message: "Minimum 2 characters required"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Operator Name</FormLabel>
                            <FormControl>
                                <Input placeholder="John Doe" className="rounded-md border-foreground/20 focus-visible:border-primary bg-background" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Contact Email</FormLabel>
                            <FormControl>
                                <Input type="email" placeholder="john@company.com" className="rounded-md border-foreground/20 focus-visible:border-primary bg-background" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />
            </div>

            <FormField control={control} name="partNumber" rules={{
      required: "Part number is required for accurate support"
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Siemens Part Number / Model</FormLabel>
                        <FormControl>
                            <Input placeholder="e.g., 6FC5370-0AA00-3AA0" className="rounded-md border-foreground/20 focus-visible:border-primary bg-background font-mono" {...field} />
                        </FormControl>
                        <FormDescription className="font-mono text-[10px]">Required for precise component matching and availability checks.</FormDescription>
                        <FormMessage />
                    </FormItem>} />

            <FormField control={control} name="message" rules={{
      required: "Inquiry details are required",
      minLength: {
        value: 10,
        message: "Please provide more details"
      }
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Technical Specifications / Issue Description</FormLabel>
                        <FormControl>
                            <Textarea placeholder="Describe the required part, current machine state, or specific technical requirements..." className="min-h-[150px] rounded-md border-foreground/20 focus-visible:border-primary bg-background resize-y" {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>} />

            {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
                    <p className="text-destructive text-sm font-mono">{submitError}</p>
                </div>}

            <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto rounded-md bg-primary hover:bg-primary/90 text-primary-foreground font-mono uppercase tracking-wider px-8">
                {isSubmitting ? <>
                        <Loader className="animate-spin mr-2 size-4" />
                        Processing...
                    </> : <>
                        Transmit Inquiry
                        <ArrowRight className="ml-2 size-4" />
                    </>}
            </Button>
        </Form>;
}
export default function ProductInquiry() {
  return;
}